var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-20 max-w-lg mx-auto mt-20 mx-2"},[_c('Intro',{attrs:{"page":_vm.page}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }